/**
 * @desc getItemPromotions
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.getItemPromotions.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getItemPromotions`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
